module.exports = __webpack_public_path__ + "img/2-icono-mistramites-selected.1997666b.svg";